import type { IUser } from 'interfaces/IUser';

/** The user's selected team id, or undefined when no team is selected. */
export const selectedTeamId = (user?: IUser | null): string | undefined =>
  user?.selected_team?.id ? String(user.selected_team.id) : undefined;
